import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import { Container } from 'react-bootstrap';

const CertBadge = ({ cert, index }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const spring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(28px)',
    delay: index * 80,
    config: { tension: 200, friction: 28 },
  });

  return (
    <animated.a
      ref={ref}
      style={spring}
      href={cert.badgeUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="cert-badge"
      title={cert.name}
    >
      <div className="cert-badge-img-wrap">
        <img src={cert.imageUrl} alt={cert.name} className="cert-badge-img" />
      </div>
      <p className="cert-badge-name">{cert.name}</p>
      <p className="cert-badge-issuer">{cert.issuer}</p>
    </animated.a>
  );
};

const Certifications = ({ heading, certificationData }) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const headerSpring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(-20px)',
  });

  return (
    <section className="certs-section">
      <Container>
        <animated.div ref={ref} style={headerSpring}>
          <h2 className="display-4 pb-5 text-center">{heading}</h2>
        </animated.div>
        <div className="certs-grid">
          {certificationData.map((cert, i) => (
            <CertBadge key={i} cert={cert} index={i} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Certifications;
